module.exports = __webpack_public_path__ + "img/rowimage-3.a5edf887.png";